import { render } from "./MPSIIIALeukocytes.vue?vue&type=template&id=fc0a5b52&scoped=true"
import script from "./MPSIIIALeukocytes.vue?vue&type=script&lang=js"
export * from "./MPSIIIALeukocytes.vue?vue&type=script&lang=js"

import "./MPSIIIALeukocytes.vue?vue&type=style&index=0&id=fc0a5b52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc0a5b52"]])

export default __exports__